"use client";

import { Menu } from "@chakra-ui/react";
import { usePathname, useRouter } from "next/navigation";
import { useAuth } from "@/state/globalStore";
import WithMenu from "@/shared/ui/actions/WithMenu";
import WithMenuItem from "@/shared/ui/actions/WithMenuItem";
import type { PublicNavLinks } from "../publicNavLinks";
import { getPublicAppEntry } from "./publicAppEntry";

export default function PublicNavbarBurgerMenu({
  navLinks,
  isAuthenticatedServerSide = false,
}: {
  navLinks: PublicNavLinks;
  isAuthenticatedServerSide?: boolean;
}) {
  const router = useRouter();
  const pathname = usePathname();
  const { user } = useAuth();

  const isAuth = !!user || !!isAuthenticatedServerSide;
  const publicAppEntry = getPublicAppEntry({
    isAuthenticated: isAuth,
    pathname,
  });

  return (
    <WithMenu placement="bottom" icon="burger_menu" size="md">
      <Menu.ItemGroup>
        <WithMenuItem
          value="home"
          humanReadable="Go to the home page"
          onClick={() => router.push("/")}
        >
          Home
        </WithMenuItem>
        {navLinks.map((link) => (
          <WithMenuItem
            key={link.title}
            value={link.title}
            humanReadable={link.description}
            onClick={() => router.push(link.href)}
          >
            {link.title}
          </WithMenuItem>
        ))}
      </Menu.ItemGroup>

      <Menu.Separator />

      <WithMenuItem
        value={publicAppEntry.label}
        humanReadable={publicAppEntry.description}
        onClick={() => router.push(publicAppEntry.href)}
      >
        {publicAppEntry.label}
      </WithMenuItem>
    </WithMenu>
  );
}
